import { Box, styled } from "@mui/material";

export const LayoutDashboardsBackground = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: "grid",
  height: "100%",
  gridTemplateRows: "auto auto",
  rowGap: theme.spacing(1),
}));
